import { useMutation } from '@tanstack/react-query';
import { postLogin as postLoginService } from 'services/api/postLogin';

export const usePostLogin = () => {
    const {
        mutate: postLogin,
        isPending,
        ...rest
    } = useMutation({
        mutationFn: postLoginService,
    });

    return { postLogin, isPending, ...rest };
};
